import { useEffect, useState } from "react";
import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import { useAddFaqMutation, useUpdateFaqMutation } from "../service/cms";
import { showError, showToast } from "../constants/toasts";

interface AddFaqModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  getFaqList: () => void;
  selectedId: string;
  selectedFaq: any;
}

export default function AddFaq({
  open,
  onClose,
  setOpen,
  getFaqList,
  selectedFaq,
  selectedId,
}: AddFaqModalProps) {
  const [updateFaq] = useUpdateFaqMutation();
  const [addFaqData] = useAddFaqMutation();
  const [error, setError] = useState(false);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");

  const [loading, setLoading] = useState(false);

  const handleAddFaq = async () => {
    setError(true);
    if (question.trim() === "") {
      showError("Question is required");
      return;
    }
    if (answer.trim() === "") {
      showError("Answer is required");
      return;
    }
    if (question.trim().length < 10) {
      showError("Minimum 10 characters are required for question");
      return;
    }
    if (answer.trim().length < 10) {
      showError("Minimum 10 characters are required for answer");
      return;
    }
    setLoading(true);
    try {
      const body = {
        question: question,
        answer: answer,
        id: selectedId,
      };
      let response;
      if (selectedId) {
        response = await updateFaq(body).unwrap();
      } else {
        response = await addFaqData(body).unwrap();
      }
      if (response?.status === 200) {
        setError(false);
        setOpen(false);
        showToast(
          selectedId ? "FAQ updated successfully" : "FAQ added successfully"
        );
        getFaqList();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && selectedFaq) {
      setQuestion(selectedFaq.question || "");
      setAnswer(selectedFaq.answer || "");
    } else if (open && !selectedFaq) {
      setQuestion("");
      setAnswer("");
    }
  }, [open, selectedFaq]);

  return (
    <Modal
      className="modal addNotification_modal"
      open={open}
      onClose={() => {
        onClose();
        setError(false);
      }}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add FAQ</h2>
            <div className="btn-close" onClick={() => setOpen(false)} tabIndex={0} role="button">
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <TextField
                variant="outlined"
                placeholder="Question"
                fullWidth
                value={question}
                onChange={(e) => {
                  if (e.target.value === " " || e.target.value === ".") {
                  } else {
                    setQuestion(e.target.value);
                  }
                }}
                hiddenLabel
              />
              {error && question == "" ? (
                <h6 className="err_msg">Question is required</h6>
              ) : error && question?.length < 10 ? (
                <h6 className="err_msg">Minimum 10 characters are required</h6>
              ) : (
                ""
              )}
            </div>
            <div className="control_group">
              <TextField
                variant="outlined"
                placeholder="Answer"
                fullWidth
                hiddenLabel
                multiline
                value={answer}
                onChange={(e) => {
                  if (e.target.value === " " || e.target.value === ".") {
                  } else {
                    setAnswer(e.target.value);
                  }
                }}
                maxRows={5}
                minRows={5}
              />
              {error && answer == "" ? (
                <h6 className="err_msg">Answer is required</h6>
              ) : error && answer?.length < 10 ? (
                <h6 className="err_msg">Minimum 10 characters are required</h6>
              ) : (
                ""
              )}
            </div>
            <div className="footer_btn_flex">
              <Button
                role="button"
                tabIndex={0}
                className="btn btn_grey"
                onClick={() => {
                  setError(false);
                  setOpen(false);
                  setQuestion("");
                  setAnswer("");
                }}
              >
                Cancel
              </Button>
              <Button role="button" tabIndex={0} className="btn btn_primary" onClick={handleAddFaq}>
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
